import { useIsWorkerClassificationEnabled } from '~/selectors';
import { useUserSelector } from '../useUserSelector';

export const useCanPostShifts = () => {
  const user = useUserSelector();
  const isWorkerClassificationEnabled = useIsWorkerClassificationEnabled();

  if (!user) {
    return false;
  }

  const allowedRequest = user?.allowedRequest || {};
  const missingWorkerClassification =
    isWorkerClassificationEnabled && !user?.workerClassification?.classificationType;

  return allowedRequest?.tempOrMdbShifts && !missingWorkerClassification;
};
